import React from 'react';
import { Box, Container } from '@mui/material';
import { useAppBarConfig } from '../../context/AppBarContext';

/**
 * PageShell
 * Standard page wrapper for /student/* routes.
 * Registers the page's AppBar config with the persistent AppBarProvider
 * so the StudentPortal shell can render a single, non-remounting AppBar.
 *
 * Set appBar={false} to suppress the AppBar entirely (e.g. full-screen scanner).
 *
 * @param {string}    [title]
 * @param {string}    [subtitle]
 * @param {*}         [backTo]
 * @param {ReactNode} [action]
 * @param {boolean}   [appBar=true]
 * @param {string}    [maxWidth='sm']
 * @param {ReactNode} [hero]
 * @param {ReactNode} children
 */
function PageShell({ title, subtitle, backTo, action, appBar = true, maxWidth = 'sm', hero, children }) {
  if (appBar === false) {
    return <PageShellBare hero={hero} maxWidth={maxWidth}>{children}</PageShellBare>;
  }
  return (
    <PageShellWithAppBar
      title={title}
      subtitle={subtitle}
      backTo={backTo}
      action={action}
      maxWidth={maxWidth}
      hero={hero}
    >
      {children}
    </PageShellWithAppBar>
  );
}

function PageShellBare({ hero, maxWidth, children }) {
  return (
    <Box sx={{ bgcolor: 'transparent', minHeight: '100vh' }}>
      {hero && <Box>{hero}</Box>}
      <Container
        maxWidth={maxWidth}
        sx={{
          px: 2,
          pt: 2,
          pb: { xs: 'calc(72px + env(safe-area-inset-bottom))', md: 4 },
        }}
      >
        {children}
      </Container>
    </Box>
  );
}

function PageShellWithAppBar({ title, subtitle, backTo, action, maxWidth, hero, children }) {
  useAppBarConfig(
    { title, subtitle, backTo, action },
    [title, subtitle, backTo, action]
  );

  return (
    <Box sx={{ bgcolor: 'transparent', minHeight: '100vh' }}>
      {hero && <Box>{hero}</Box>}
      <Container
        maxWidth={maxWidth}
        sx={{
          px: 2,
          pt: 2,
          pb: { xs: 'calc(72px + env(safe-area-inset-bottom))', md: 4 },
        }}
      >
        {children}
      </Container>
    </Box>
  );
}

export default PageShell;
